import { combineReducers } from "@reduxjs/toolkit";
import profile from "./userSlice";

const reducer = combineReducers({
  profile,
});

export default reducer;
